import { type } from "@core/util";
import { Action } from "@ngrx/store";
import { Account, Subscription } from "@core/store/account/account.model";

export const ActionTypes = {
  LOAD: type("[Account] Load"),
  LOAD_SUCCESS: type("[Account] Load Success"),
  LOAD_FAIL: type("[Account] Load Fail"),
  UPDATE_BILLING_INFO: type("[Account] Update BillingInfo"),
  UPDATE_BILLING_INFO_SUCCESS: type("[Account] Update BillingInfo Success"),
  UPDATE_BILLING_INFO_FAIL: type("[Account] Update BillingInfo Fail"),
  UPDATE_BILLING_INFO_3D_SECURE_REQUIRED: type(
    "[Account] Update BillingInfo 3D Secure Required",
  ),
  CREATE_SUBSCRIPTION: type("[Account] Create Subscription"),
  CREATE_SUBSCRIPTION_SUCCESS: type("[Account] Create Subscription Success"),
  CREATE_SUBSCRIPTION_FAIL: type("[Account] Create Subscription Fail"),
  CREATE_SUBSCRIPTION_3D_SECURE_REQUIRED: type(
    "[Account] Create Subscription 3D Secure Required",
  ),
  CANCEL_SUBSCRIPTION: type("[Account] Cancel Subscription"),
  CANCEL_SUBSCRIPTION_SUCCESS: type("[Account] Cancel Subscription Success"),
  CANCEL_SUBSCRIPTION_FAIL: type("[Account] Cancel Subscription Fail"),
  CHANGE_SUBSCRIPTION: type("[Account] Change Subscription"),
  CHANGE_SUBSCRIPTION_SUCCESS: type("[Account] Change Subscription Success"),
  CHANGE_SUBSCRIPTION_FAIL: type("[Account] Change Subscription Fail"),
  REDEEM_COUPON: type("[Account] Redeem Coupon"),
  REDEEM_COUPON_SUCCESS: type("[Account] Redeem Coupon Success"),
  REDEEM_COUPON_FAIL: type("[Account] Redeem Coupon Fail"),
};

export class LoadAccountAction implements Action {
  type = ActionTypes.LOAD;
}

export class LoadAccountSuccessAction implements Action {
  type = ActionTypes.LOAD_SUCCESS;
  constructor(public payload: Account) {}
}

export class LoadAccountFailAction implements Action {
  type = ActionTypes.LOAD_FAIL;
}

export class UpdateBillingInfoAction implements Action {
  type = ActionTypes.UPDATE_BILLING_INFO;
  constructor(
    public token: string,
    public threeDSecureToken: string,
  ) {}
}

export class UpdateBillingInfoSuccessAction implements Action {
  type = ActionTypes.UPDATE_BILLING_INFO_SUCCESS;
  constructor(public payload: Account) {}
}

export class UpdateBillingInfoFailAction implements Action {
  type = ActionTypes.UPDATE_BILLING_INFO_FAIL;
  constructor(public payload: any) {}
}

export class UpdateBillingInfo3DSecureRequiredAction implements Action {
  type = ActionTypes.UPDATE_BILLING_INFO_3D_SECURE_REQUIRED;
  constructor(
    public token: string,
    public threeDSecureToken?: string,
  ) {}
}

export class CreateSubscriptionAction implements Action {
  type = ActionTypes.CREATE_SUBSCRIPTION;
  constructor(
    public plan: string,
    public token?: string,
    public threeDSecureToken?: string,
  ) {}
}

export class CreateSubscriptionSuccessAction implements Action {
  type = ActionTypes.CREATE_SUBSCRIPTION_SUCCESS;
  constructor(public payload: Subscription) {}
}

export class CreateSubscriptionFailAction implements Action {
  type = ActionTypes.CREATE_SUBSCRIPTION_FAIL;
}

export class CreateSubscription3DSecureRequiredAction implements Action {
  type = ActionTypes.CREATE_SUBSCRIPTION_3D_SECURE_REQUIRED;
  constructor(
    public plan: string,
    public token: string,
    public threeDSecureToken?: string,
  ) {}
}

export class CancelSubscriptionAction implements Action {
  type = ActionTypes.CANCEL_SUBSCRIPTION;
  constructor(public payload: string) {}
}

export class CancelSubscriptionSuccessAction implements Action {
  type = ActionTypes.CANCEL_SUBSCRIPTION_SUCCESS;
  constructor(public payload: Subscription) {}
}

export class CancelSubscriptionFailAction implements Action {
  type = ActionTypes.CANCEL_SUBSCRIPTION_FAIL;
}

export class ChangeSubscriptionAction implements Action {
  type = ActionTypes.CHANGE_SUBSCRIPTION;
  constructor(
    public uuid: string,
    public plan: string,
  ) {}
}

export class ChangeSubscriptionSuccessAction implements Action {
  type = ActionTypes.CHANGE_SUBSCRIPTION_SUCCESS;
  constructor(public payload: Subscription) {}
}

export class ChangeSubscriptionFailAction implements Action {
  type = ActionTypes.CHANGE_SUBSCRIPTION_FAIL;
}

export class RedeemCouponAction implements Action {
  type = ActionTypes.REDEEM_COUPON;
  constructor(public payload: string) {}
}

export class RedeemCouponSuccessAction implements Action {
  type = ActionTypes.REDEEM_COUPON_SUCCESS;
  // TODO: typing
  constructor(public payload: any) {}
}

export class RedeemCouponFailAction implements Action {
  type = ActionTypes.REDEEM_COUPON_FAIL;
}

export type Action =
  | LoadAccountAction
  | LoadAccountSuccessAction
  | LoadAccountFailAction
  | UpdateBillingInfoAction
  | UpdateBillingInfoSuccessAction
  | UpdateBillingInfoFailAction
  | CreateSubscriptionAction
  | CreateSubscriptionSuccessAction
  | CreateSubscriptionFailAction
  | CancelSubscriptionAction
  | CancelSubscriptionSuccessAction
  | CancelSubscriptionFailAction
  | RedeemCouponAction
  | RedeemCouponSuccessAction
  | RedeemCouponFailAction;



// WEBPACK FOOTER //
// /app/src/app/core/store/account/account.actions.ts